import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { VIEW_NAMES_PERMISSION, VIEW_PEDIGREE_INFORMATION_PERMISSION } from '../shared/auth/permissions';
import { GermplasmDetailsContext } from './germplasm-details.context';
import { ActivatedRoute, Router } from '@angular/router';
import { FileService } from '../shared/file/service/file.service';
import { GermplasmDto } from '../shared/germplasm/model/germplasm.model';
import { GermplasmService } from '../shared/germplasm/service/germplasm.service';
import { GermplasmDetailsUrlService } from '../shared/germplasm/service/germplasm-details.url.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { JhiEventManager } from '../shared/core-utils';
import { MAX_NAME_DISPLAY_SIZE } from '../app.constants';

@Component({
    selector: 'jhi-germplasm-details-main',
    templateUrl: './germplasm-details-main.component.html'
})
export class GermplasmDetailsMainComponent implements OnInit, OnDestroy {

    protected readonly MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
    protected readonly VIEW_NAMES_PERMISSION = VIEW_NAMES_PERMISSION;
    protected readonly VIEW_PEDIGREE_INFORMATION_PERMISSION = VIEW_PEDIGREE_INFORMATION_PERMISSION;
    safeUrl: SafeResourceUrl;
    hasChanges: boolean;
    isFileStorageConfigured: boolean;
    germplasm: GermplasmDto;
    initialTab: string;

    constructor(private router: Router,
                public germplasmDetailsContext: GermplasmDetailsContext,
                private route: ActivatedRoute,
                private fileService: FileService,
                private germplasmService: GermplasmService,
                private germplasmDetailsUrlService: GermplasmDetailsUrlService,
                private eventManager: JhiEventManager) {
    }

    ngOnInit(): void {
        const gid = this.route.snapshot.paramMap.get('gid');
        this.germplasmDetailsContext.gid = Number(gid);
        this.germplasmDetailsContext.isModal = true;
        this.germplasmDetailsContext.openedFromWorkbench = true;
        // Link to open Germplasm Details page to a new browser tab.
        this.safeUrl = this.germplasmDetailsUrlService.getUrl(this.germplasmDetailsContext.gid);
        this.initialTab = this.route.snapshot.paramMap.get('initialTab') || 'germplasm-basic-details';
        this.hasChanges = this.route.snapshot.paramMap.get('hasChanges') === 'true';
        this.fileService.isFileStorageConfigured().then((isFileStorageConfigured) => this.isFileStorageConfigured = isFileStorageConfigured);
        this.loadGermplasm();
    }

    loadGermplasm() {
        this.germplasmService.getGermplasmById(this.germplasmDetailsContext.gid).toPromise().then((value) => {
            this.germplasm = value.body;
            // After the germplasm is loaded, navigate to the initial tab.
            this.navigateToTab(this.germplasmDetailsContext.gid, this.initialTab);
        });
    }

    navigateToTab(gid, route: string) {
        this.router.navigate([{
            outlets: {
                'germplasmDetailsPopup': ['germplasm-details-main', gid, {
                    outlets: {
                        'modalContent': [route]
                    }
                }]
            }
        }], { queryParamsHandling: 'preserve' });
    }


    @HostListener('window:message', ['$event'])
    onMessage(event) {
        if (event.data === 'germplasm-details-changed') {
            this.hasChanges = true;
            this.loadGermplasm();
        }
    }

    ngOnDestroy(): void {
        // When the germplasm details modal is closed and any germplasm details have changed,
        // broadcast a germplasmDetailsChanged event.
        if (this.hasChanges) {
            this.eventManager.broadcast({ name: 'germplasmDetailsChanged' });
        }
    }

}
